export default __webpack_public_path__ + "cc66caa16e617b5592722687345c5414.coffee";